import indignant from '../../../../assets/svgs/actors/sasha/indignant'
import popularGirl from '../../../../assets/svgs/actors/sasha/popularGirl'

import {
    INDIGNANT,
    POPULAR_GIRL,
} from '../../../../constants/scene/actors/sasha'

export default {
    [INDIGNANT]: indignant,
    [POPULAR_GIRL]: popularGirl,
}
